<template>
  <div class="collection">
    <toolbar>
      <template v-slot:left v-if="$slots.action">
        <record-count :records="records" :name="name" />
      </template>
      <template v-slot:center>
        <div class="collection__filters">
          <span class="collection__sort" v-if="options.sort">
            <select-input
              v-model="sortValue"
              :options="sortOptions"
              @input="reload"
            />
          </span>
          <span class="collection__search">
            <text-input
              v-model="searchValue"
              :placeholder="placeholder"
              @input="emit"
            />
          </span>
        </div>
      </template>
    <template v-slot:right v-if="$slots.action">
        <slot name="action"></slot>
      </template>
    </toolbar>
    <loader fill v-if="loading"></loader>
    <div class="collection__body" v-else>
      <div class="collection__toggle" v-if="$slots.toggle">
        <slot name="toggle"></slot>
      </div>
      <div class="collection__custom" v-if="$slots.custom">
        <slot name="custom"></slot>
      </div>
      <div class="collection__grid" :class="gridClass" v-else>
        <div v-for="(record, index) in records" :key="index">
          <slot name="item" v-bind:record="record"></slot>
        </div>
      </div>
    </div>
    <jump-to-top />
  </div>
</template>

<script>
import Fuse from 'fuse.js';
import sortOptions from '@/utilities/sortOptions';
import Loader from './Loader.vue';
import RecordCount from './RecordCount.vue';
import Toolbar from './Toolbar.vue';
import TextInput from './TextInput.vue';
import SelectInput from './SelectInput.vue';
import JumpToTop from './JumpToTop.vue';

export default {
  name: 'Collection',
  components: {
    Loader,
    RecordCount,
    TextInput,
    SelectInput,
    Toolbar,
    JumpToTop,
  },
  props: {
    loading: Boolean,
    name: String,
    data: Array,
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    columns: {
      type: Number,
      default: 2,
    },
    value: Object,
  },
  data() {
    return {
      searchValue: null,
      sortValue: this.$route.query.sort || sortOptions[0].value,
      sortOptions,
    };
  },
  computed: {
    placeholder() {
      return `Search ${this.name}s`;
    },
    records() {
      if (this.searchValue) {
        const searchOptions = this.options && this.options.search;
        const searchAPI = new Fuse(this.data, searchOptions);
        return searchAPI.search(this.searchValue).map(result => result.item);
      }
      return this.data;
    },
    gridClass() {
      return `columns-${this.columns}`;
    },
  },
  methods: {
    reload() {
      this.$router.push({ query: { sort: this.sortValue } });
      this.emit();
    },
    emit() {
      const { sortValue, searchValue } = this;
      this.$emit('input', { sortValue, searchValue });
    },
  },
  created() {
    this.emit();
  },
};
</script>

<style lang="scss" scoped>
.collection {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  &__body {
    margin-top: 30px;
  }
  &__filters {
    display: flex;
    width: 520px;
    max-width: 100%;
    > * {
      margin: 0 5px;
    }
  }
  &__search {
    flex: 1;
  }
  &__toggle {
    text-align: center;
    margin-bottom: 30px;
  }
  &__grid {
    display: grid;
    width: 100%;
    grid-template-columns: 1fr 1fr;
    margin: 0 auto;
    &.columns-1 {
      grid-template-columns: 1fr;
      max-width: 520px;
    }
    @media all and (max-width: 800px) {
      grid-template-columns: auto;
    }
    @media all and (max-width: 600px) {
      padding: 0;
    }
    div {
      margin-bottom: 20px;
    }
  }
}
</style>
